import { Modal, Stack, Form, Button, Table } from "react-bootstrap";
import React from "react";
import getProductos_manifiesto from "../../functions/Produccion/getProductos_manifiesto";
import editarTotal_facturas_manifiesto from "../../functions/Produccion/editarTotal_facturas_manifiesto";
import getAllProducts from "../../functions/Produccion/getAllProducts"
import {DatePicker} from "@material-ui/pickers";
import Swal from "sweetalert2";

function ModalAñadir_manifiesto_facturas({
  isModalAñadir_Manifiesto_facturas,
  setModalAñadir_Manifiesto_facturasON,
  setManifiestos_pallets_datos,
  actualizarEstadoManifiestos,
  productoEditar,
  productos_manifiestos,
  usuario,
  Manifiesto_Seleccionado,
}) {

  //Convertir a formato moneda
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  })


/* async function actualizar_manifiestos(){
  const pagina = "Manifiestos";
     await getAllProducts(pagina).then((productos) => {
        //Con esto lo ordeno por fechas de forma descendiente
        productos.sort((a,b)=>  (b.fecha3) - (a.fecha3));
        setManifiestos_pallets_datos = productos;
        console.log(productos);
      });     
} */

const [Categorias_del_manifiesto, setCategorias_del_manifiesto] = React.useState([]);

async function Manifiesto_actual(){
  await getProductos_manifiesto(Manifiesto_Seleccionado).then((productos_manifiestoDB) => {

//Con estos map consigo todos los tipos diferentes de pallets que se ingresaron sin repetir y se guarda en productos_resultados-----------------
var productos_resultados = [];
productos_manifiestoDB.map((dato, auxiliar)=>{
var auxiliar100 = false;  
 //Con este if me aseguro que el primer dato se mande directo ya que esta vacio el arreglo 
        if(auxiliar==0){
          //dato['Resultado_pallets']= dato.cantidad_retirada;
        }else{
        //Con este map comparo si ya existe en el arreglo creado el producto que se esta analizando y si ya existe solo se suma la cantidad si no se agrega directo
        productos_resultados.map((valor)=>{
            if(dato.categoria_pallet==valor.categoria_pallet){
              auxiliar100 = true;
              //auxiliar101 = valor;
            }
          })//Fin segundo map
        }//Fin else del primer if

  if(auxiliar100==true){

  }else{
    productos_resultados.push(dato);
  }
})//Fin primer map

setCategorias_del_manifiesto(productos_resultados)
  })
}

  function añadirProductoModal() {

    var Arreglo_con_facturas = [];
    Categorias_del_manifiesto.map((dato, auxiliar)=>{ 
      var auxiliar_final= {[dato.categoria_pallet]: document.getElementById(auxiliar+1).value};
               Arreglo_con_facturas.push(auxiliar_final)
    })
        console.log(Arreglo_con_facturas)

    const infoProducto = { Arreglo_con_facturas
      };

    editarTotal_facturas_manifiesto(Arreglo_con_facturas, Manifiesto_Seleccionado);
    // cerrar modal
    setModalAñadir_Manifiesto_facturasON(false); 
    //actualizar_manifiestos();
  }

  
  React.useEffect(() => {
    Manifiesto_actual();
  }, []);

  return (
    <Modal show={isModalAñadir_Manifiesto_facturas} onHide={() => {
    setModalAñadir_Manifiesto_facturasON(false);
    }}>
      <Modal.Header>
        <Modal.Title>Agregar facturas</Modal.Title>
      </Modal.Header>
        <Modal.Body>
        <Table id="" style={{ fontSize: 14 }} className="container-fluid">
          <thead>
              <tr >
              <th>Categorias</th>
              <th>Precio de factura</th>
                  </tr>
              </thead>
          <tbody>
          {Categorias_del_manifiesto &&
              Categorias_del_manifiesto.map((datos, index) => (
                <tr key={index}>
                  <td>{datos.categoria_pallet}</td>
                  <td>
                    <Form.Control
                        id= {index+1}
                        placeholder={datos.Precio_caja}
                        type="number"
                        className="mb-1"
                      /> 
                  </td>
                  
                </tr>
              ))}
          </tbody> 
        </Table>
        </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setModalAñadir_Manifiesto_facturasON(false)}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={añadirProductoModal}>
          Añadir
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ModalAñadir_manifiesto_facturas;